import React, { useState, useEffect } from 'react'
import Layout from 'components/LayoutForPortal'
import { Row, Col, Button, Form, Input,  Spin, message, } from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import { DataRequestAction, DataGetAction } from '../../../redux/actions/http'
import { PlusOutlined } from '@ant-design/icons';
import ReactQuill from 'react-quill'
import 'react-quill/dist/quill.snow.css';
import SubQuestion from '../components/SubQuestionModal'
import useDynamicRefs from 'use-dynamic-refs';
const Index = () => {

    const ModalType = "SubQuestion-Modal"
    const dispatch = useDispatch();
    const [getRef, setRef] = useDynamicRefs();
    const dailyActivityProps = useSelector(state => state.dailyLivingActivityR);

    const { dailyActivityLoader,
        settingId,
        dailyActivitySuccess,
        dailyActivityError, dailyBaseLine, fetchingLoader, selectedQuestion } = dailyActivityProps;

    const QuestionObjectArray = dailyBaseLine;


    const [supQuestions, setSubQuestionQuestion] = useState({})
    const [questionCount, setQuestionCount] = useState(0)
    const [selectedQuestionIndex, setselectedQuestion] = useState(0)

    const [form] = Form.useForm();


    if (dailyActivitySuccess) {
        message.success("Record updated successfully");
        dispatch({
            type: "dailyLivingActivity_reset_state"
        })
    }

    if (dailyActivityError) {
        message.error("Some error occur while updating record");
        dispatch({
            type: "dailyLivingActivity_reset_state"
        })
    }

    const fetchSetting = () => {
        dispatch(DataGetAction('getQuestionnaireSetting', '', 'fetchingSetting'));
    }

    useEffect(fetchSetting, [])

    const setDailyCount = () => {
        if (QuestionObjectArray && QuestionObjectArray.questions) {
            setQuestionCount(QuestionObjectArray.questions.length)
        }
    }

    useEffect(setDailyCount, [QuestionObjectArray])


    const onFinish = (data) => {
        data.questions.forEach((Item, index) => {
            if (Item.questionOptionType === "With Image") {
                Item.questionOptionImage.forEach((item, childIndex) => {
                    if (item.image_optionLabel && item.image_optionLabel.file) {
                        item.image_optionLabel = item.image_optionLabel.file.response.url
                    }
                    if (item.furtherDetail) {
                        let key = index + ".questionOptionImage." + childIndex
                        if (supQuestions[key]) {
                            item.subQuestion = supQuestions[key]
                        }
                    }
                })
            }
        })
        let dataObj = { "arrayKey": "dailyBaseLine", value: data };
        if (settingId) {
            dataObj._id = settingId
        }
        dispatch(DataRequestAction('POST', 'updateQuestionnaire', dataObj, '', 'savingDailyLivingActivity', false));
    }

    const executeScroll = (index) => {
        const id1 = getRef(`questionId_${index}`);
        setselectedQuestion(index);
        id1.current.scrollIntoView({ behavior: "smooth" });;
    }

    const handleChange = (key, data) => {
        form.setFieldsValue({ [key]: data });
    }

    const renderGermanEditor = (type) => {
        return <ReactQuill onChange={(data) => handleChange(type, data)} />
    }



    const renderFormListWithOutImage = (key, checkValue) => {
            return <Form.List name={key}>
                {(fields, { add, remove }) => (
                    <>
                        {fields.map((field, index) => (
                            <Row>
                                <Col xl={24} lg={24} md={24} sm={24} xs={24}>
                                    <Row className="">
                                        <Col xl={1} lg={1} md={1} sm={1} xs={1}>
                                            <span style={{
                                                display: 'flFex',
                                                flex: 1,
                                                height: '60%',
                                                justifyContent: 'center',
                                                alignItems: 'center'
                                            }}>{index + 1}</span>
                                        </Col>
                                        <Col xl={14} lg={14} md={14} sm={22} xs={22}>
                                            <Form.Item
                                                name={[field.name, 'optionLabel']}
                                                fieldKey={[field.fieldKey, 'optionLabel']}
                                                rules={[{ required: true, message: 'Missing Option Label' }]}
                                            >
                                                <Input placeholder="optionLabel" style={{ width: 250 }} />
                                            </Form.Item>
                                        </Col>
                                        <Col xl={4} lg={4} md={4} sm={2} xs={2}>
                                            <Button type="dashed" className="gx-pt-0" onClick={() => remove(field.name)}>
                                                <span style={{ color: 'red' }}>Delete</span>
                                            </Button>
                                        </Col>
                                    </Row>
                                    <Row className="gx-mr-3">
                                        <Col xl={24} lg={24} md={24} sm={24} xs={24} >
                                            <Form.Item
                                                className="quilEditor"
                                                name={[field.name, 'decisionTree']}
                                                fieldKey={[field.fieldKey, 'decisionTree']}
                                                rules={[{ required: true, message: 'Missing decision Tree' }]}
                                                initialValue=''
                                            >
                                                {renderGermanEditor([field.name, 'decisionTree'])}
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        ))
                        }
                        <Form.Item>
                            <Button type="dashed" className="gx-pt-0" style={{ maxWidth: '700px' }} onClick={() => add()} block icon={<PlusOutlined />}>
                                Add options
                </Button>
                        </Form.Item>
                    </>
                )}
            </Form.List>
      
    }


    const increaseQuestionCount = () => {
        let newCount = questionCount + 1;
        setQuestionCount(newCount);
    }

    const reduceQuestionCount = () => {
        let newCount = questionCount - 1;
        setQuestionCount(newCount);
    }

    const renderQuestionCountNumber = () => {

        var foo = [];
        for (var i = 1; i <= questionCount; i++) {
            foo.push(i);
        }
        return foo.map(Item => {
            return <span to={`#${Item}_question`} onClick={() => executeScroll(Item-1)} className={`gx-link gx-d-block gx-pb-1 ${selectedQuestionIndex === Item-1?"selectedQuestion":""}`}><h5>{Item}</h5></span>
        })
    }


    const setSubQuestionQuestionFn = (data) => {
        let subQuestion = supQuestions;
        subQuestion[selectedQuestion] = data
        setSubQuestionQuestion({ ...subQuestion });
        dispatch({
            type: ModalType,
            payload: null

        })
    }

    return (
        <Layout>
            {fetchingLoader ?
                <Spin size="large" color="blue" />
                : <Form
                    name="dynamic_form_nest_item"
                    onFinish={onFinish}
                    autoComplete="off"
                    initialValues={QuestionObjectArray}
                >

                    <Row>
                        <Col xl={24} lg={24} md={24} sm={24} xs={24}>
                            <h1 className="gx-d-flex gx-flex-row gx-justify-content-between gx-font-18">
                            Daily Baseline
                        <Form.Item className="gx-mb-2">
                                    {dailyActivityLoader ?
                                        <Spin size="small" color="white"><Button type="primary" disabled htmlType="submit" className="gx-pt-0 gx-mb-0">
                                            Save
                                        </Button></Spin>
                                        : <Button type="primary" htmlType="submit" className="gx-pt-0 gx-mb-0">
                                            Save
                                        </Button>
                                    }
                                </Form.Item>
                            </h1>
                        </Col>
                    </Row>

                    <Row>
                        <Col xl={24} lg={24} md={24} sm={24} xs={24}>
                            <Form.Item
                                name="dailyLivingActivityText"
                                rules={[{ required: true, message: 'Daily Living Activity Text' }]}
                                initialValue={QuestionObjectArray.dailyLivingActivityText ? QuestionObjectArray.dailyLivingActivityText : ''}
                            >
                                {renderGermanEditor('dailyLivingActivityText')}
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row>

                        <Col xl={24} lg={24} md={24} sm={24} xs={24}>
                            <div>
                                <Form.List name="questions">
                                    {(fields, { add, remove }) => (
                                        <>
                                            <Row className="gx-mt-3 gx-mr-1">
                                                <Col xl={24} lg={24} md={24} sm={24} xs={24}>
                                                    <div className="gx-d-flex gx-flex-row gx-justify-content-between questionHeader gx-align-items-center gx-mb-3">
                                                        <h1 className="gx-font-18">Daily Baseline Question</h1>
                                                        <Form.Item className="gx-mb-0">
                                                            <Button type="dashed" className="gx-pt-0 gx-mb-0" onClick={() => { add(); increaseQuestionCount() }} icon={<PlusOutlined />}>
                                                                Add Question
                                                        </Button>
                                                        </Form.Item>
                                                    </div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col xl={2} lg={2} md={2} sm={2} xs={2}>
                                                    <div className="showQuestionCount">
                                                        <div>
                                                            <span>Sr.no</span>
                                                        </div>
                                                        {renderQuestionCountNumber()}
                                                    </div>
                                                </Col>

                                                <Col xl={22} lg={22} md={22} sm={22} xs={22} style={{ height: '600px', overflowY: 'scroll' }}>
                                                    {fields.map((field, index) => (
                                                        <section className="questionContainer" ref={setRef(`questionId_${index}`)} key={field.key} id={`${index + 1}_question`}>
                                                            <Row className="gx-m-0 gx-p-0">
                                                                <Col xl={24} lg={24} md={24} sm={24} xs={24} className="gx-p-0">
                                                                    <h1 className="questionContainerHeader">
                                                                        <span>Question No: {index + 1}</span>
                                                                        <Button type="dashed" className="gx-pt-0" onClick={() => { remove(field.name); reduceQuestionCount() }}>
                                                                            <span style={{ color: 'red' }}>Delete</span>
                                                                        </Button>
                                                                    </h1>
                                                                </Col>
                                                            </Row>
                                                            <Row style={{
                                                                padding: '30px 27px'
                                                            }}>
                                                                <Col xl={24} lg={24} md={24} sm={24} xs={24}>
                                                                    <Row className="gx-mr-3">
                                                                        <Col xl={4} lg={4} md={4} sm={24} xs={24} className="gx-text-left">
                                                                            <span>Question label</span>
                                                                        </Col>
                                                                        <Col xl={18} lg={18} md={18} sm={22} xs={22} className="gx-text-left">
                                                                            <Form.Item
                                                                                name={[field.name, 'questionLabel']}
                                                                                fieldKey={[field.fieldKey, 'questionLabel']}
                                                                                rules={[{ required: true, message: 'Missing Question Label' }]}
                                                                            >
                                                                                <Input placeholder="Question Label" style={{ width: 500 }} />
                                                                            </Form.Item>
                                                                            <Form.Item
                                                                                name={[field.name, 'questionType']}
                                                                                fieldKey={[field.fieldKey, 'questionType']}
                                                                                initialValue="Radio"
                                                                            >
                                                                                <Input placeholder="Question Label" disabled value="Radio" style={{ width: 500 }} />
                                                                            </Form.Item>
                                                                            <Form.Item
                                                                                name={[field.name, 'questionOptionType']}
                                                                                fieldKey={[field.fieldKey, 'questionOptionType']}
                                                                                initialValue="Without Image"
                                                                            >
                                                                                <Input placeholder="Question Label" disabled value="Without Image" style={{ width: 500 }} />
                                                                            </Form.Item>
                                                                        </Col>
                                                                    </Row>
                                                                </Col>
                                                                 <Col xl={24} lg={24} md={24} sm={24} xs={24} className="gx-p-0">
                                                                    {renderFormListWithOutImage([field.name, 'questionOption'], [field.name, 'questionOptionType'])}
                                                                </Col>

                                                            </Row>
                                                        </section>
                                                    ))}
                                                </Col>
                                            </Row>
                                        </>
                                    )}
                                </Form.List>
                            </div>
                        </Col>
                    </Row>

                </Form>
            }

            <SubQuestion modalType={ModalType} setSubQuestion={(data) => setSubQuestionQuestionFn(data)} />
        </Layout>
    )
}

export default Index
